// extracted by mini-css-extract-plugin
module.exports = {"tooltipIcon":"TooltipIcon_tooltipIcon__3o4qF","top":"TooltipIcon_top__idkUs","left":"TooltipIcon_left__1Wq7a"};